module.exports = __webpack_public_path__ + "img/icon-fish-active.f36c82a.webp";